import { Container, Button, Form, Alert, Tab, Tabs } from 'react-bootstrap';
import { Sida, Rubrik, Stycke, ContentWrapper } from "../ContentStyles";
import React, { useState, useEffect, useRef } from 'react';
import useBackend, { CallAPI, CallAPI_v2, SpinnerX, CallAPIGet } from '../../services/useBackend';
import "./Login.scss";
import { Branding } from '../../services/misc';
import { FaChartLine } from "react-icons/fa";
import { TfiPencilAlt } from "react-icons/tfi";
import QRCode from "react-qr-code";

export default function Login() {

	const resultDefault = { Visible: false, Text: '', error: false, Variant: 'success' };
	const [result, setResult] = useState({});
	const [spinnerHidden, setSpinnerHidden] = useState(true);

	const [bankIDorderRef, setBankIDorderRef] = useState('');
	const [bankIdQRValue, setBankIdQRValue] = useState('');
	const [authTab, setAuthTab] = useState('password');
	const [useLocaldevice, setUseLocaldevice] = useState(false);

	const qRTimer = useRef(0);

	useEffect(() => {
		const interval = setInterval(async () => {
			if (qRTimer.current > 0) await updateBankID();
		}, 1000);

		return () => { clearInterval(interval); };
	}, [bankIDorderRef]);

	async function handleAuthPassword(e) {
		e.preventDefault();
		setSpinnerHidden(false);

		const formData = new FormData(e.target),
			formDataObj = Object.fromEntries(formData.entries())
		var PostData = { SystemID: "NS", AuthData: formDataObj };

		let { result, jsondata } = await CallAPI_v2('/backend/auth/password', 'POST', JSON.stringify(PostData));

		if (result.error == false) {
			setResult(result);
			setSpinnerHidden(true);
			localStorage.setItem('access_token', jsondata.access_token);

			var RedirectTo = "/shops";

			if (jsondata.redirectTo != "") RedirectTo = jsondata.redirectTo;

			setTimeout(function () { window.location.href = RedirectTo; }, 1400);
		} else {
			setResult(result);
			setSpinnerHidden(true);
		}
	}

	async function updateBankID() {
		let { result, jsondata } = await CallAPI_v2('/api/auth/BankIDAuthState/' + bankIDorderRef, 'GET');
		setResult(result);
		qRTimer.current = (30 - jsondata.qr_diff);

		if (jsondata.status == "complete") {
			qRTimer.current = 0;
			setBankIDorderRef('');
			localStorage.setItem('access_token', jsondata.access_token);

			var RedirectTo = "/shops";
			if (jsondata.redirectTo != "") RedirectTo = jsondata.redirectTo;

			setTimeout(function () { window.location.href = RedirectTo; }, 1400);
		}
		setBankIdQRValue(jsondata.qr_token);
	}

	async function initBankID(useLocaldevice = false) {
		let { result, jsondata } = await CallAPI_v2('/api/auth/BankIDAuthInit', 'POST', JSON.stringify({}));
		setBankIDorderRef(jsondata.orderRef);
		setUseLocaldevice(useLocaldevice);
		qRTimer.current = 30;

		if (useLocaldevice) {
			const link = document.createElement("a");
			link.href = jsondata.autoStartTokenFull + "&redirect=https://www.närbutik.se/shops";
			link.referrerPolicy = "origin";
			// link.click();
		} else {
		}

		setResult(result);
	}

	async function selectAuthTab(key) {
		await setResult(resultDefault);
		await setAuthTab(key);
		if (key == 'password') qRTimer.current = 0;
		if (key == 'bankid') initBankID();
	}

	return (
		<ContentWrapper>
			<Container>
				<Sida>
					<div className="login-page">
						<div className="login-page__bg" aria-hidden="true"></div>

						<div className="login-page__grid">
							<div className="login-page__left">

								<h2 className="login-page__title">
									Välkommen tillbaka till
								</h2>

								<p className="login-page__subtitle">
									Logga in för att hantera dina butiker, se statistik och mycket mer.
								</p>

								<div className="login-page__features">
									<div className="login-page__featureCard">
										<div className="login-page__featureDot" aria-hidden="true"><TfiPencilAlt /></div>
										<div>
											<div className="login-page__featureHeading">Administrera dina varor och butiker</div>
											<div className="login-page__featureText">Enkelt att lägga till varor eller justera priser</div>
										</div>
									</div>

									<div className="login-page__featureCard">
										<div className="login-page__featureDot" aria-hidden="true"><FaChartLine /></div>
										<div>
											<div className="login-page__featureHeading">Se besök och försäljning</div>
											<div className="login-page__featureText">Full kontroll i realtid</div>
										</div>
									</div>
								</div>
							</div>

							<div className="login-page__right">
								<div className="login-card">
									<div className="login-card__header">
										<h3>Logga in</h3>
										<p>Ange dina uppgifter för att fortsätta</p>
									</div>

									<Tabs defaultActiveKey={authTab} id="uncontrolled-tab-example" className="mb-3 login-tabs" onSelect={(i) => selectAuthTab(i)}>
										<Tab eventKey="password" title="Lösenord">
											<Form onSubmit={handleAuthPassword}>
												<Form.Group className="mb-3">
													<Form.Label className="FormHeaderText">Email</Form.Label>
													<Form.Control autoFocus type="email" name="username" />
												</Form.Group>

												<Form.Group className="mb-3">
													<Form.Label className="FormHeaderText">Password</Form.Label>
													<Form.Control type="password" name="password" />
												</Form.Group>

												<Form.Group className="mb-3" hidden={!result.Visible}>
													<Alert show={result.Visible} variant={result.Variant} className="FormSpace_">{result.Text}</Alert>
												</Form.Group>

												<Form.Group className="mb-3" hidden={spinnerHidden}>
													<SpinnerX />
												</Form.Group>

												<Form.Group className="mb-3">
													<Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="submit">Login</Button>
												</Form.Group>

												<Form.Group className="mb-3">
													<a href="/password/request/new" className="text-decoration-none" style={{ color: '#000', fontSize: '16px' }}>Glömt lösenord</a>
												</Form.Group>
											</Form>
										</Tab>


										<Tab eventKey="bankid" title="BankID">
											<Form>
												<Form.Group className="mb-3" >
													<div className="login-page__featureHeading" style={{ margin: "16px" }}>
														<QRCode value={bankIdQRValue} size="100%" title="QR" fgColor={Branding().ButtonColor} hidden={useLocaldevice}></QRCode>

														<div style={{ color: Branding().ButtonColor, textAlign: "center", width: "100%", marginTop: "4px" }} >{qRTimer.current} sekunder kvar</div>

														{qRTimer.current == 0 && <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor, marginTop: "4px" }} variant="primary" type="submit" onClick={(e) => { e.preventDefault(); initBankID(useLocaldevice); }}>Starta om</Button>}

														<Button hidden={useLocaldevice} className="QmeButton" style={{ backgroundColor: Branding().ButtonColor, marginTop: "4px" }} variant="primary" type="submit" onClick={(e) => { e.preventDefault(); initBankID(true); }}>Använd BankID på denna enheten</Button>

														<Button hidden={!useLocaldevice} className="QmeButton" style={{ backgroundColor: Branding().ButtonColor, marginTop: "4px" }} variant="primary" type="submit" onClick={(e) => { e.preventDefault(); initBankID(false); }}>Använd BankID med QR-Kod</Button>
													</div>
												</Form.Group>

												<Form.Group className="mb-3">
													<div className="login-page__featureHeading" style={{ fontSize: "16px" }}>
														<ol>
															<li>Öppna BankID på din mobil</li>
															<li>Klicka på Scanna QR-kod</li>
															<li>Identifiera dig</li>
														</ol>

													</div>
												</Form.Group>

												{/* <Form.Group className="mb-3"  hidden={!result.Visible}>
													<Alert  show={result.Visible} variant={result.Variant}  className="FormSpace_" >{result.Text}</Alert> 
												</Form.Group>   */}

												{/* <Tab eventKey="bankid" title="BankID"> 
										<Form>
											<div className="bankid-wrapper">
											<div className="bankid-card">
												<div className="bankid-qr">
												<QRCode
													value={bankIdQRValue}
													viewBox={'0 0 512 512'}
													size={256}
													bgColor="#ffffff"
													fgColor="#000000"
												/>
												</div>

												<p className="bankid-text">
												Öppna BankID-appen och skanna QR-koden
												</p>}
											</div>
											</div> */}

												<Form.Group className="mb-3" hidden={spinnerHidden}>
													<SpinnerX />
												</Form.Group>
											</Form>
										</Tab>



									</Tabs>
								</div>
							</div>
						</div>
					</div>
				</Sida>
			</Container>
		</ContentWrapper>
	);
}